export default __webpack_public_path__ + "static/media/player-jill-colour-desk@2x.32928b20.png";